module.exports = __webpack_public_path__ + "img/text-classify11.605bce8e.svg";